/* @flow */
/*jshint esversion: 6 */
import { Button, Form, Icon, Input, InputNumber, message, Spin, Tooltip } from "antd";
import React, { Component } from "react";
import "../../App.css";
import "./ItemsForAutoIphone.css";
import LangContext from "../../contextProvider/LangContext";
import ExcludedItems from "./ExcludedItems";
import GenericModal from "../../components/GenericModal";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import GenericTable from "../../components/GenericTable";
import { escapeRegExp } from "lodash";
import TableLineIcons from "../../components/TableLineIcons";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import ResponsiveTable from "../../components/ResponsiveTable";
import moment from "moment";

const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

class ItemsForAutoIphone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            modalDataOpen: false,
            filterTags: "",

            modalOrder: null,
            modalTags: null,
            modalBarcode2: null,
            modalLastDocs: null,

            orderPriceEdit: null,
            orderQtyEdit: null,
            orderRecommendationEdit: null,

        }

        this.id = "ITEMS_TO_COTO"
        this.id_rec = "PURCHASE_RECOMMENDATION_TO_COTO"
        this.id_last10 = "PURCHASE_DOCS_LAST_10_TO_COTO"

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData }
        if (props.data[this.id_rec] === undefined) props.data[this.id_rec] = { ...props.data.genericData }
        if (props.data[this.id_last10] === undefined) props.data[this.id_last10] = { dataset: [] }

        this.api = {
            get: "get_items_to_coto",
            get_rec: "get_purchase_recommendation_to_coto",
            get_last10: "get_last_10_purchase_docs",
        }

    }



    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    renderRecPrice = (text, record) => {
        return (<>
            {formatter.format(text)} <Icon type="edit" onClick={() => {
                this.setState({ orderPriceEdit: record })
            }} />
            <GenericModal
                visible={this.state.orderPriceEdit?.key == record.key}
                onCancel={() => { this.setState({ orderPriceEdit: null }) }}
                width={300}>
                <div style={{ textAlign: "center" }}>
                    <h4>{this.getText(22417)} {this.state.modalOrder?.mName}</h4>
                    <h4>{this.getText(22418)} {this.state.orderPriceEdit?.PriceListId} - {this.state.orderPriceEdit?.PriceListName}</h4>
                    <br />
                    <InputNumber
                        precision={2} min={0} max={99999.99}
                        value={this.state.orderPriceEdit?.Price}
                        onChange={e => { this.setState({ orderPriceEdit: { ...this.state.orderPriceEdit, Price: e } }) }}
                    />
                    <br />
                    <Icon type="close" style={{ color: "red", fontSize: 25, margin: 25 }} onClick={() => {
                        this.setState({ orderPriceEdit: null })
                    }} />
                    <Icon type="check" style={{ color: "green", fontSize: 25, margin: 25 }} onClick={() => {
                        this.sendAPI("edit_price_by_item", {
                            mId: this.state.orderPriceEdit?.PriceListId,
                            mItem: this.state.modalOrder?.mCode,
                            mPriceVal: this.state.orderPriceEdit?.Price
                        }, () => {
                            this.setState({ orderPriceEdit: null }, () => {
                                this.props.dataActions.genericDataGetRequested(
                                    this.id_rec, this.props.user.companyCode, this.props.user.token, this.api.get_rec);
                            })
                        })
                    }} />
                </div>
            </GenericModal>
        </>)
    }



    renderRecItemQuantity = (text, record) => {

        return (<>
            {formatter.format(text)} {text > 0 ?
                <Icon type="edit" onClick={() => { this.setState({ orderQtyEdit: record }) }} />
                : <Icon type="edit" style={{ color: "#aaaaaa" }} />}
            <br />
            {this.getText(22416)}: {formatter.format(record.minimum)}
            <GenericModal
                visible={this.state.orderQtyEdit?.key == record.key}
                onCancel={() => { this.setState({ orderQtyEdit: null }) }}
                width={300}>
                <div style={{ textAlign: "center" }}>
                    <h4>{this.getText(22419)} {this.state.modalOrder?.mName}</h4>
                    <h4>{this.getText(22420)} {this.state.orderQtyEdit?.storageName}</h4>
                    <h4>{this.getText(22421)}</h4>
                    <br />
                    <h4>{this.getText(22422)}: {formatter.format(record.ItemQuantity)}</h4>
                    <h4>{this.getText(22423)}: <InputNumber
                        precision={2} min={0} max={record.ItemQuantity}
                        value={this.state.orderQtyEdit?.ItemQuantity}
                        onChange={e => { this.setState({ orderQtyEdit: { ...this.state.orderQtyEdit, ItemQuantity: e } }) }}
                    /></h4>
                    <Icon type="close" style={{ color: "red", fontSize: 25, margin: 25 }} onClick={() => {
                        this.setState({ orderQtyEdit: null })
                    }} />
                    <Icon type="check" style={{ color: "green", fontSize: 25, margin: 25 }} onClick={() => {
                        let _qty = record.ItemQuantity - this.state.orderQtyEdit?.ItemQuantity
                        if (_qty > 0) {
                            this.sendAPI("create_transfer_to_waster", {
                                _storage: record.storageId,
                                _item: this.state.modalOrder?.mCode,
                                _qty,
                                _pos: record.Pos,
                            }, () => {
                                this.setState({ orderQtyEdit: null }, () => {
                                    this.props.dataActions.genericDataGetRequested(
                                        this.id_rec, this.props.user.companyCode, this.props.user.token, this.api.get_rec);
                                })
                            })
                        } else {
                            message.error(this.getText(22424))
                        }
                    }} />
                </div>
            </GenericModal>
        </>)
    }

    renderRecPurchaseRecommendation = (text, record) => {

        return (<>
            {formatter.format(text)} <Icon type="edit" onClick={() => {
                this.setState({ orderRecommendationEdit: record })
            }} />
            <GenericModal
                visible={this.state.orderRecommendationEdit?.key == record.key}
                onCancel={() => { this.setState({ orderRecommendationEdit: null }) }}
                width={300}>
                <div style={{ textAlign: "center" }}>
                    <h4>{this.getText(22425)}</h4>
                    <h4>{this.getText(22426)} {this.state.modalOrder?.mName}</h4>
                    <h4>{this.getText(22427)} {this.state.orderRecommendationEdit?.storageName}</h4>
                    <br />
                    <h4>{this.getText(22428)}: {formatter.format(record.PurchaseRecommendation)}</h4>
                    <h4>{this.getText(22429)}: <InputNumber
                        precision={2} min={0} max={99999.99}
                        value={this.state.orderRecommendationEdit?.PurchaseOk}
                        onChange={e => { this.setState({ orderRecommendationEdit: { ...this.state.orderRecommendationEdit, PurchaseOk: e } }) }}
                    /></h4>
                    <Icon type="close" style={{ color: "red", fontSize: 25, margin: 25 }} onClick={() => {
                        this.setState({ orderRecommendationEdit: null })
                    }} />
                    <Icon type="check" style={{ color: "green", fontSize: 25, margin: 25 }} onClick={() => {
                        let data = this.props.data[this.id_rec].data.map(x => {
                            let y = x.split("\f")
                            if (record.key == y[0]) {
                                y[9] = this.state.orderRecommendationEdit.PurchaseOk
                                return y.join("\f")
                            } else {
                                return x
                            }
                        })

                        this.setState({ orderRecommendationEdit: null }, () => {
                            this.props.dataActions.setJson(this.id_rec, { data })
                        })
                    }} />
                </div>
            </GenericModal>
        </>)
    }

    getLast10Docs = (r) => {
        this.setState({ modalLastDocs: r }, () => {
            this.sendAPI(this.api.get_last10, { _item: this.state.modalOrder?.mCode, _storage: r.storageId }, ob => {
                let dataset = ob.data ?
                    ob.data.split("\r").map((x, index) => {
                        const [dNum, dDatetime, dQty, dUnitCost] = x.split("\f");
                        return { key: dNum, index, dNum, dDatetime, dQty, dUnitCost }
                    })
                    : []
                this.props.dataActions.setJson(this.id_last10, { dataset })
            })
        })
    }

    apiTags = (_item) => {
        this.sendAPI("get_item_tags", { _item }, ob => {
            let tagList = []
            let tagDefault = null
            if (ob.data) {
                ob.data.split("\r").forEach(x => {
                    const [y, d] = x.split("\f")
                    tagList.push(y)
                    if (d == 1) tagDefault = y
                })
            }
            this.setState({ modalTags: { ...this.state.modalTags, tagList, tagDefault } })
        })
    }

    apiBarcode2 = (_item) => {
        this.sendAPI("get_item_barcode2_list", { _item }, ob => {
            let list = (ob.data) ?
                ob.data.split("\r").map((x, index) => {
                    const [code, barcode2] = x.split("\f")
                    return { key: code, index, code, barcode2 }
                })
                : []
            this.setState({ modalBarcode2: { ...this.state.modalBarcode2, list, editing: null } })
        })
    }

    saveItemTags = () => {

        this.sendAPI("set_item_tags", {
            _item: this.state.modalTags?.mCode,
            _tagList: this.state.modalTags?.tagList?.join(","),
            _default: this.state.modalTags?.tagDefault,
        }, () => {
            this.setState({ modalTags: null })
        })
    }

    renderBarcode2 = (barcode2, record) => {
        if (record.code == this.state.modalBarcode2?.editing?.code) {
            return (<Input
                value={this.state.modalBarcode2?.editing?.barcode2}
                onChange={e => { this.setState({ modalBarcode2: { ...this.state.modalBarcode2, editing: { ...record, barcode2: e.target.value } } }) }}
            />)
        } else {
            return barcode2
        }
    }

    renderEditBarcode2 = (code, record) => {
        if (code == this.state.modalBarcode2?.editing?.code) {
            return (<TableLineIcons
                onCheck={() => {
                    this.sendAPI("check_if_exsist_barcode2", { _code: code, _barcode2: this.state.modalBarcode2?.editing?.barcode2 }, (ob) => {
                        if (ob.data) {
                            message.error(ob.data)
                        } else {
                            this.sendAPI("add_barcode2", {
                                _item: this.state.modalBarcode2?.mCode,
                                _name: this.state.modalBarcode2?.mName,
                                _code2: code,
                                _barcode2: this.state.modalBarcode2?.editing?.barcode2,
                            }, () => {
                                this.apiBarcode2(this.state.modalBarcode2?.mCode)
                            })
                        }
                    })
                }}
                onClose={() => {
                    this.setState({
                        modalBarcode2: {
                            ...this.state.modalBarcode2,
                            list: this.state.modalBarcode2.list.filter(f => f.code),
                            editing: null
                        }
                    })
                }}
            />)
        } else {
            return (<TableLineIcons
                onEdit={() => { this.setState({ modalBarcode2: { ...this.state.modalBarcode2, editing: record } }) }}
                deleteQuetion={{ title: this.getText(22450), okText: this.getText(22451), cancelText: this.getText(22452) }}
                onDelete={() => { this.sendAPI("delete_item", code, () => { this.apiBarcode2(this.state.modalBarcode2?.mCode) }) }}
            />)
        }
    }

    onCreatePurchaseDoc = () => {
        const { createList } = this.state.modalPurchaseCreate
        if (createList?.length) {
            this.sendAPI("create_temp_purchase_doc_from_coto", createList[0], (ob) => {
                const [DocPosID, DocNum] = ob.data ? ob.data.split("\f") : []
                this.sendAPI("save_temp_document", { DocNum, DocTypeID: 4, DocPosID, isDeleteDraft: 1 }, () => {
                    this.setState({ modalPurchaseCreate: { ...this.state.modalPurchaseCreate, createList: createList.slice(1) } }, this.onCreatePurchaseDoc)
                })
            })
        } else {
            this.setState({ modalPurchaseCreate: null }, () => {
                this.props.dataActions.genericDataGetRequested(
                    this.id_rec, this.props.user.companyCode, this.props.user.token, this.api.get_rec);
            })
        }
    }

    render() {
        let headerData = {}
        if (this.props.data[this.id]) {
            const { data, headers } = this.props.data[this.id]
            if (data[0]) {
                let y = data[0].split("\f")
                headers.forEach((x, i) => { headerData = { ...headerData, [x]: y[i] } })
            }
        }
        const gt = this.getText


        const titleCostAndPrice1 = (
            <div className="coto-split-header">
                <div className="coto-split-header-col">
                    <div className="coto-header-title">{gt(22398)}</div>
                </div>
                <div className="coto-split-header-divider" />
                <div className="coto-split-header-col">
                    <div className="coto-header-title">{headerData.mPrice1Name}</div>
                    <div className="coto-header-sub">
                        {gt(headerData.mPrice1IncludeVat == 1 ? 22400 : 22399)}
                    </div>
                </div>
            </div>
        )

        const titlePrice2 = (
            <div className="coto-col-header-single">
                <div className="coto-header-title">{headerData.mPrice2Name}</div>
                <div className="coto-header-sub">
                    {gt(headerData.mPrice2IncludeVat == 1 ? 22400 : 22399)}
                </div>
            </div>
        )

        const renderCostAndPrice1 = (t, r) => {
            let profit = r.mPriceNoTax && r.mCost ? r.mPriceNoTax - r.mCost : 0
            let profitUp = profit && parseFloat(r.mPriceNoTax) ? profit / r.mPriceNoTax : 0
            let profitDown = profit && parseFloat(r.mCost) ? profit / r.mCost : 0
            return (
                <div className="coto-price-block">
                    <div className="coto-price-row">
                        <div className="coto-price-cell">
                            <div className="coto-price-value">{formatter.format(t)}</div>
                        </div>
                        <div className="coto-price-divider" />
                        <div className="coto-price-cell">
                            <div className="coto-price-value">{formatter.format(r.mPrice1)}</div>
                        </div>
                    </div>
                    <div className="coto-profit-row">
                        <span className="coto-profit-badge">{gt(22402)}: {parseInt(profitUp * 100)}%</span>
                        <span className="coto-profit-badge down">{gt(22403)}: {parseInt(profitDown * 100)}%</span>
                    </div>
                </div>
            )
        }

        const renderEdit = (t, r) => {
            return (
                <div className="coto-actions">
                    <TableLineIcons genericIcons={[
                        { type: "select", onClick: () => { this.setState({ modalOrder: r }) }, tooltip: gt(22404) },
                        { type: "tags", onClick: () => { this.setState({ modalTags: r }, () => { this.apiTags(r.mCode) }) }, tooltip: gt(22405) },
                        { type: "table", onClick: () => { this.setState({ modalBarcode2: r }, () => { this.apiBarcode2(r.mCode) }) }, tooltip: gt(22406) },
                    ]} />
                </div>
            )
        }

        let orderSum = 0
        if (this.props.data[this.id_rec]?.data) {
            this.props.data[this.id_rec].data.forEach(x => {
                let y = x.split("\f")
                orderSum += y[9] && parseFloat(y[9]) ? parseFloat(y[9]) : 0
            })
        }
        return (<div style={{ textAlign: "center", marginBottom: 24, display: 'inline-block', verticalAlign: 'text-top' }}>
            <Button onClick={() => { this.setState({ modalOpen: true }) }}>
                <Icon type={"shopping-cart"} style={{ marginLeft: 5 }} />
                {gt(22391)}
            </Button>
            <GenericModal
                visible={this.state.modalOpen}
                onCancel={() => { this.setState({ modalOpen: false }) }}
                title={gt(22392)}
                width={500}
                footer={[
                    <Button onClick={() => { this.setState({ modalOpen: false }) }}>{gt(22394)}</Button>,
                    <Button onClick={() => { this.setState({ modalDataOpen: true }) }} type="primary">{gt(22393)}</Button>,
                ]}
            >
                <Form.Item label={gt(22395)}>
                    <GenericSelectorItemTags
                        {...this.props} multi
                        value={this.state.filterTags ? this.state.filterTags.split(",") : []}
                        onChange={e => { this.setState({ filterTags: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
            </GenericModal>

            <GenericModal
                visible={this.state.modalDataOpen}
                onCancel={() => { this.setState({ modalDataOpen: false }) }}
                title={gt(22396)}
                width={800}
                showsearch={(val) => {
                    this.props.dataActions.genericDataSetFilter(
                        this.id, this.props.user.companyCode, this.props.user.token,
                        {
                            _words: escapeRegExp(val),
                            page: 1,
                            _page_num: 1,
                        }, this.api.get)
                }}
            >
                {this.state.modalDataOpen ?
                    <div className="coto-items-table">
                        <GenericTable
                            {...this.props} tableOnly
                            rowHeight={94}
                            id={this.id}
                            getApi={this.api.get}
                            columns={[
                                {
                                    title: <div className="coto-header-title">{gt(22397)}</div>,
                                    key: "mCode", dataIndex: "mCode", width: "22%",
                                    render: (t, r) => (
                                        <div className="coto-item-info">
                                            <div className="coto-item-code">{t}</div>
                                            <div className="coto-item-name">{r.mName}</div>
                                        </div>
                                    ),
                                },
                                { title: titleCostAndPrice1, key: "mCost", dataIndex: "mCost", width: "38%", render: renderCostAndPrice1 },
                                {
                                    title: titlePrice2, key: "mPrice2", dataIndex: "mPrice2", width: "20%",
                                    render: t => <span className="coto-price2">{formatter.format(t)}</span>,
                                },
                                { title: <div className="coto-header-title">{gt(22401)}</div>, width: "20%", render: renderEdit },
                            ]}
                            filters={{ _tagList: this.state.filterTags }}
                        />
                    </div>
                    : ""}
                <GenericModal
                    visible={this.state.modalOrder != null}
                    onCancel={() => {
                        this.setState({ modalOrder: null }, () => {
                            this.props.dataActions.genericDataGetRequested(
                                this.id, this.props.user.companyCode, this.props.user.token, this.api.get)
                        })
                    }}
                    title={(<>
                        {gt(22407)}: {this.state.modalOrder?.mCode} &nbsp;&nbsp;&nbsp;
                        {gt(22408)}: {this.state.modalOrder?.mName} &nbsp;<br />
                        &nbsp;{gt(22409)}: {formatter.format(orderSum)}
                    </>)}
                    height={60}
                    width={500}
                    genericActionButtons={[
                        <Button onClick={() => { this.setState({ modalPurchaseCreate: true }) }}>{gt(22410)}</Button>
                    ]}
                >
                    {this.state.modalOrder ?
                        <GenericTable
                            {...this.props} tableOnly
                            id={this.id_rec}
                            getApi={this.api.get_rec}
                            columns={[// "storageId", "storageName", "Pos", "Price", "PriceListId", "PriceListName", "ItemQuantity", "minimum", "PurchaseRecommendation"
                                { title: gt(22411), key: "storageId", dataIndex: "storageId", width: "20%", render: (t, r) => `${t} - ${r.storageName}` },
                                { title: gt(22412), key: "Price", dataIndex: "Price", width: "20%", render: this.renderRecPrice },
                                { title: gt(22413), key: "ItemQuantity", dataIndex: "ItemQuantity", width: "20%", render: this.renderRecItemQuantity },
                                { title: gt(22414), key: "PurchaseOk", dataIndex: "PurchaseOk", width: "20%", render: this.renderRecPurchaseRecommendation },
                                { title: gt(22415), width: "20%", render: (t, r) => (<Tooltip title={gt(22430)}><Icon type="table" onClick={() => { this.getLast10Docs(r) }} /></Tooltip>) },
                            ]}
                            filters={{ _item: this.state.modalOrder?.mCode }}
                            pagination={{ pageSize: parseInt((window.innerHeight - 400) / 40) }}
                        />
                        : ""}
                    <GenericModal
                        visible={this.state.modalLastDocs != null}
                        onCancel={() => { this.setState({ modalLastDocs: null }) }}
                        title={(<>
                            {gt(22430)} {this.state.modalOrder?.mName}<br />
                            {gt(22431)} {this.state.modalLastDocs?.storageName}
                        </>)}
                        height={60}
                        width={500}
                        footer={[<Button onClick={() => { this.setState({ modalLastDocs: null }) }}>{gt(22436)}</Button>]}
                    >
                        <ResponsiveTable
                            tableOnly
                            dataSource={this.props.data[this.id_last10]?.dataset ?? []}
                            columns={[
                                { title: gt(22432), key: "dDatetime", dataIndex: "dDatetime", width: "30%", render: t => moment(t).format("DD/MM/YYYY") },
                                { title: gt(22433), key: "dNum", dataIndex: "dNum", width: "30%", render: t => t },
                                { title: gt(22434), key: "dQty", dataIndex: "dQty", width: "20%", render: t => formatter.format(t) },
                                { title: gt(22435), key: "dUnitCost", dataIndex: "dUnitCost", width: "20%", render: t => formatter.format(t) },
                            ]}
                            pagination={false}
                        />
                    </GenericModal>

                    <GenericModal
                        visible={this.state.modalPurchaseCreate}
                        onCancel={() => { this.setState({ modalPurchaseCreate: false }) }}
                        width={400}>
                        <div style={{ textAlign: "center" }}>
                            <h3>{gt(22437)}: {this.state.modalOrder?.mName}</h3>
                            <br />
                            {gt(22438)}: {formatter.format(orderSum)} {gt(22439)}
                            <br />
                            {gt(22440)}: <InputNumber
                                precision={2} min={0} max={99999.99}
                                value={this.state.modalOrder?.mCost}
                                onChange={e => { this.setState({ modalOrder: { ...this.state.modalOrder, mCost: e } }) }}
                            /> {gt(22441)}
                            <br />
                            {this.state.modalPurchaseCreate?.createList?.length ? <Spin /> : [
                                <Icon type="close" style={{ color: "red", fontSize: 25, margin: 25 }} onClick={() => {
                                    this.setState({ modalPurchaseCreate: false })
                                }} />,
                                <Icon type="check" style={{ color: "green", fontSize: 25, margin: 25 }} onClick={() => {
                                    const { mCode, mName, mBarCode, mCost } = this.state.modalOrder
                                    let createList = []
                                    this.props.data[this.id_rec].data.forEach(x => {
                                        let y = x.split("\f")
                                        if (y[9] > 0) createList.push({ _storage: y[0], _item: mCode, _barcode: mBarCode, _name: mName, _cost: mCost, _qty: y[9] })
                                    })
                                    this.setState({ modalPurchaseCreate: { ...this.state.modalPurchaseCreate, createList } }, this.onCreatePurchaseDoc)
                                }} />]}
                        </div>
                    </GenericModal>
                </GenericModal>
                <GenericModal
                    visible={this.state.modalTags != null}
                    onCancel={() => { this.setState({ modalTags: null }) }}
                    title={`${gt(22446)} ${this.state.modalTags?.mName}`}
                    width={500}
                    footer={[
                        <Button onClick={() => { this.setState({ modalTags: null }) }}>{gt(22444)}</Button>,
                        <Button type="primary" onClick={this.saveItemTags}>{gt(22445)}</Button>,
                    ]}
                >
                    <Form.Item label={gt(22442)}>
                        <GenericSelectorItemTags
                            {...this.props} multi notApi
                            value={this.state.modalTags ? this.state.modalTags.tagList : []}
                            onChange={e => { this.setState({ modalTags: { ...this.state.modalTags, tagList: e } }) }}
                        />
                    </Form.Item>

                    <Form.Item label={gt(22443)}>
                        <GenericSelectorItemTags
                            {...this.props} notApi
                            filterList={this.state.modalTags ? this.state.modalTags.tagList : []}
                            value={this.state.modalTags?.tagDefault}
                            onChange={e => { this.setState({ modalTags: { ...this.state.modalTags, tagDefault: e } }) }}
                        />
                    </Form.Item>

                </GenericModal>
                <GenericModal
                    visible={this.state.modalBarcode2 != null}
                    onCancel={() => { this.setState({ modalBarcode2: null }) }}
                    title={(<>
                        {gt(22447)} {this.state.modalBarcode2?.mName} <br />
                        &nbsp;{gt(22448)} {this.state.modalBarcode2?.mBarCode}
                    </>)}
                    width={400}
                    height={70}
                    actionButtons={[{
                        buttonType: 'add',
                        buttonFunction: () => {
                            this.setState({
                                modalBarcode2: {
                                    ...this.state.modalBarcode2,
                                    list: [{ code: "", barcode2: "" }, ...this.state.modalBarcode2.list],
                                    editing: { code: "", barcode2: "" }
                                }
                            })
                        }
                    }]}
                >
                    <ResponsiveTable
                        tableOnly
                        dataSource={this.state.modalBarcode2?.list ?? []}
                        columns={[
                            { title: gt(22448), key: "barcode2", dataIndex: "barcode2", width: "80%", render: this.renderBarcode2 },
                            { title: gt(22449), key: "code", dataIndex: "code", width: "30%", render: this.renderEditBarcode2 },
                        ]}
                        pagination={false}
                    />
                </GenericModal>
            </GenericModal>
        </div>)
    }
}

export default ItemsForAutoIphone;